/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FC } from "react";

import classNames from "classnames";
import ReactTooltip, { TooltipProps } from "react-tooltip";
import { v4 as uuid } from "uuid";

import { QuestionIcon } from "components/icons";

type Props = {
  name?: string;
  tooltipArgs?: TooltipProps;
  children: React.ReactNode;
  className?: string;
  tooltipClassName?: string;
  customIcon?: React.ReactNode;
  arrowColor?: string;
};

const Tooltip: FC<Props> = ({
  children,
  name,
  tooltipArgs,
  className,
  customIcon,
  tooltipClassName,
  arrowColor,
}) => {
  const id = name || uuid();

  return (
    <div test-id="aalr-NnM">
      <div
        data-tip
        data-for={id}
        className={classNames(
          "flex w-fit items-center rounded-full p-1 px-1.5 bg-btn-inactive",
          className,
          { "!p-0 !px-0 bg-transparent": customIcon },
        )}
        test-id="2SHOFnQU"
      >
        {customIcon ?? <QuestionIcon test-id="7RI8N1E0" />}
      </div>

      <ReactTooltip
        id={id}
        className={classNames("!opacity-100", tooltipClassName)}
        arrowColor={arrowColor}
        {...tooltipArgs}
        test-id="dE3_T04p"
      >
        {children}
      </ReactTooltip>
    </div>
  );
};

export default Tooltip;
